import React, { Component, Fragment } from 'react'
import { withRouteData, Head } from 'react-static'

import RDForm from '../../../../components/site/RDForm/RDForm'

import './KitClientesInativos.scss'

class KitClientesInativos extends React.Component {
    render() {
        return (
            <Fragment>
                {this.props.headData && <Head>
                    <title>{this.props.headData.pageTitle}</title>
                    <meta property="og:title" content={this.props.headData.pageTitle} />
                    <meta name="twitter:title" content={this.props.headData.pageTitle} />
                    <meta name="description" content={this.props.headData.pageDescription} />
                    <meta property="og:description" content={this.props.headData.pageDescription} />
                    <meta name="twitter:description" content={this.props.headData.pageDescription} />
                    <meta property="og:image" content={this.props.headData.ogImage} />
                    <meta name="twitter:image" content={this.props.headData.ogImage} />
                    <meta property="og:url" content={this.props.headData.ogUrl} />
                    <link rel="canonical" href={this.props.headData.ogUrl} />
                </Head>}
                <div className='kit-clientes-inativos'>
                    <div className="hero">
                        <div className="container">
                            <div className="left-column">
                                <img src="/images/logo_mercos_footer.png" alt="Logomarca Mercos" className='logo' />
                                <h1 className="large-title">Calcule quanto dinheiro <b>"tem na mesa"</b> no seu negócio</h1>
                                <p className="paragraph"><b>Você quer aumentar seus resultados, mas não sabe como?</b> Com certeza, tem oportunidades "na palma da mão" que não estão sendo observadas. Descubra o quanto você pode ganhar a mais e como fazer isso!</p>
                                <img src="/images/site/landing-pages/kit-clientes-inativos/bill-coins.png" alt="Notas e moedas" className='bill-coins' />
                            </div>
                            <div className="right-column">
                                <p className="form-title">Preencha o formulário abaixo</p>
                                <RDForm kitClientes buttonText="Acesar Material">Acesar Material </RDForm>
                            </div>

                        </div>
                    </div>
                    <section className="container centered">
                        <h2 className="big-title">
                            Neste <b>kit gratuito</b> você vai ver:
                        </h2>
                        <div className="box-list-wrapper">
                            <div className="box-list">
                                <div className="icon"><img src="/images/site/landing-pages/b2b-rep/dot.svg" alt="" /></div>
                                <div className="box-content">
                                    <div className="box-title">Calculadora de Oportunidades</div>
                                    <div className="box-text">Calcule o quanto de receita pode receber a mais trabalhando a sua base de clientes e receba um diagnóstico das oportunidades na sua operação comercial.</div>
                                </div>
                            </div>
                            <div className="box-list">
                                <div className="icon"><img src="/images/site/landing-pages/b2b-rep/dot.svg" alt="" /></div>
                                <div className="box-content">
                                    <div className="box-title">E-book "Estratégias de Receita"</div>
                                    <div className="box-text">Um passo a passo de como identificar os dados relevantes para a análise de oportunidades de negócios, além de estratégias práticas para melhorar estes números.</div>
                                </div>
                            </div>
                        </div>

                    </section>

                </div>
            </Fragment>
        );
    }
}

export default withRouteData(props => <KitClientesInativos {...props} />)


// WEBPACK FOOTER //
// /usr/src/site-blog/src/containers/site/landing-pages/kitclientesinativos/KitClientesInativos.jsx